import React, {useEffect, useState} from "react"

import queryString from "query-string"

import {resetPasswordByEmail} from "../api"

import AlertMessage from "../../../toolkits/AlertMessage/AlertMessage"
import SmallButton from "../../../toolkits/SmallButton/SmallButton"

import {getAuthorizedUserData} from "../../../utils/localstorage.utils"

import {ERROR_CODE} from "../../../constants/other"
import {useCustomHistory} from "../../../hooks/useCustomHistory"
import {LoginRoute} from "../../../routes"
import {Link} from "react-router-dom"
import {Trans, useTranslation} from "react-i18next"

export const ResetPasswordForm = () => {
    const { t } = useTranslation("common")

    const history = useCustomHistory()

    const [email, setEmail] = useState()
    const [alertMessage, setAlertMessage] = useState(null)
    const [emailWasSent, setEmailWasSent] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const isUserAuthorized = getAuthorizedUserData()

    const handleSubmit = (e) => {
        e.preventDefault()
        e.target.disabled = true

        resetPasswordByEmail(email)
            .then(() => {
                setEmailWasSent(true)
            })
            .catch(() => {
                e.target.disabled = false
                setAlertMessage({message: t("Incorrect email, please try again."), error: ERROR_CODE})
            })
    }

    useEffect(() => {
        const params = queryString.parse(history.location.search)
        
        if (params.email) setEmail(params.email)
    }, [])

    return (<>
        {!emailWasSent ? <div>
            <div className="auth-wrapper-login-title">{t("Reset password")}</div>
            <div>
                {alertMessage && 
                    <AlertMessage setMessage={setAlertMessage} message={alertMessage?.message} code={alertMessage?.code}/> 
                }
            </div>
            <p className="auth-wrapper-reset-pass">
                <Trans ns="common" i18nKey="Enter your email so we can send you a password reset link" />
            </p>
            <form className="auth-wrapper-login-form" id="login-form">
                <label className="auth-wrapper-login-form-email-label t-s3" htmlFor="email-field">{t("Email address")}</label>
                <input
                    className="auth-wrapper-login-form-email-field"
                    id="email-field"
                    type="email"
                    placeholder={t("Email address")}
                    defaultValue={email}
                    onChange={e => setEmail(e.target.value)}
                />
                <div className="popup-bottom">
                    <div className="popup-bottom-button-container">
                        <SmallButton btnType="secondary" onClick={() => history.goBack()}>{t("Back")}</SmallButton>
                        <SmallButton
                            type="submit"
                            loading={isLoading}
                            disabled={!email}
                            onClick={(e) => {
                                setIsLoading(true)
                                handleSubmit(e)
                            }}
                        >
                            {t("Send")}
                        </SmallButton>
                    </div>
                </div>
                <div className="auth-wrapper-login-form-bottom">
                    <Link
                        to={LoginRoute.path}
                        className="auth-wrapper-login-form-bottom-return-login t-b1"
                    >
                        {t("Return to login")}
                    </Link>
                </div>
            </form>
        </div> : <div>
            <div className="auth-wrapper-login-title">{t("Reset password")}</div>
            <p className="auth-wrapper-reset-pass">
                {t("A message with a password reset link has been sent.")}
                <br/>
                {t("Please check your email")}
            </p>
            <div className="popup-bottom auth-wrapper-return-to-login">
                <SmallButton onClick={() => history.push(LoginRoute.path)}>
                    { isUserAuthorized ? t("Return to profile")  : t("Return to login")}
                </SmallButton>
            </div>
        </div>}
    </>)
}
